﻿﻿import { getUrlAction, sentryError, TestaCPF } from '../utils'
import { showMessage, showMessageBox, toast } from '../components/message'

// `select` é definido globalmente em mobile.js como window.select.
const select = (seletor, wrapper) => (wrapper || document).querySelector(seletor)

function ensureMalgaMissingFieldsStyles() {
  if (document.getElementById('malga-missing-fields-styles')) return

  const styles = document.createElement('style')
  styles.id = 'malga-missing-fields-styles'
  styles.textContent = `
    #malga-missing-fields {
      padding: 0;
      align-items: flex-end;
      background: rgba(17, 24, 39, 0.62);
      backdrop-filter: blur(3px);
    }

    #malga-missing-fields .message-box__container {
      width: 100%;
      max-width: none;
      max-height: 100dvh;
      overflow-y: auto;
      padding: 14px;
      border-radius: 12px 12px 0 0;
      background: #ffffff;
      box-shadow: 0 20px 55px rgba(15, 23, 42, 0.24);
      display: flex;
      flex-direction: column;
      gap: 11px;
      animation: malga-sheet-up 0.24s cubic-bezier(0.2, 0.85, 0.32, 1) both;
    }

    @keyframes malga-sheet-up {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      #malga-missing-fields .message-box__container {
        animation: none;
      }
    }

    #malga-missing-fields .message-box__icon {
      display: none;
    }

    #malga-missing-fields .message-box__message {
      margin: 0;
      color: #111827;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.2;
      text-align: left;
    }

    #malga-missing-fields .malga-missing-body {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    #malga-missing-fields .malga-missing-hint {
      color: #64748b;
      font-size: 12px;
      line-height: 1.3;
    }

    #malga-missing-fields .malga-missing-label {
      display: flex;
      flex-direction: column;
      gap: 6px;
      color: #1f2937;
      font-size: 12px;
      font-weight: 600;
    }

    #malga-missing-fields .malga-missing-input {
      height: 46px;
      border: 1px solid #d7dde5;
      border-radius: 6px;
      background: #ffffff;
      padding: 0 12px;
      color: #111827;
      font-size: 15px;
      font-weight: 500;
      outline: none;
    }

    #malga-missing-fields .malga-missing-input:focus {
      border-color: #2d6cdf;
      box-shadow: 0 0 0 3px rgba(45, 108, 223, 0.12);
    }

    #malga-missing-fields .malga-missing-actions {
      display: flex;
      flex-direction: column-reverse;
      gap: 8px;
      margin-top: 2px;
    }

    #malga-missing-fields .malga-missing-button {
      width: 100%;
      min-height: 42px;
      border-radius: 6px;
      padding: 0 16px;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
    }

    #malga-missing-fields .malga-missing-button-secondary {
      border: 1px solid #d7dde5;
      background: #ffffff;
      color: #344054;
    }

    #malga-missing-fields .malga-missing-button-primary {
      border: 1px solid transparent;
      background: #2d6cdf;
      color: #ffffff;
      box-shadow: 0 8px 18px rgba(45, 108, 223, 0.24);
    }

    #malga-missing-fields .malga-missing-input--error {
      border-color: #dc2626 !important;
      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
    }

    #malga-missing-fields .malga-missing-error {
      color: #dc2626;
      font-size: 11px;
      font-weight: 500;
      margin-top: -2px;
    }
  `
  document.head.appendChild(styles)
}

export function ocultaCartaoMalga(cardId) {
  if (!cardId) return

  $.ajax({
    url: getUrlAction('pedido', 'DeletarCartaoMalga'),
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ cardId }),
    error: (xhr) => {
      sentryError && sentryError(xhr)
    },
  })
}

/**
 * Consulta /Pedido/ListarCartoesMalga e devolve array normalizado de cartões
 * persistentes. Tolerante a erro: em qualquer falha resolve com [].
 * Formato: [{ cardId, brand, last4 }, ...]
 */
export function carregaCartoesMalgaSalvos() {
  return new Promise((resolve) => {
    $.ajax({
      url: getUrlAction('pedido', 'ListarCartoesMalga'),
      type: 'GET',
      success: (raw) => {
        try {
          const outer = typeof raw === 'string' ? JSON.parse(raw) : raw
          if (!outer || !outer.lValid || !outer.ret) return resolve([])
          // ret pode vir como string JSON ou array direto dependendo do endpoint.
          const inner = typeof outer.ret === 'string' ? JSON.parse(outer.ret) : outer.ret
          const items = Array.isArray(inner) ? inner : (inner && inner.items) || []
          const normalized = items
            .filter((c) => c && (c.status === 'active' || !c.status))
            .map((c) => ({
              cardId: c.cardId || c.id,
              brand: c.brand,
              last4: c.last4digits || c.lastFourDigits || c.last4 || '••••',
              alias: c.alias || c.Alias || '',
            }))
          resolve(normalized)
        } catch (e) {
          sentryError && sentryError(e)
          resolve([])
        }
      },
      error: (xhr) => {
        sentryError && sentryError(xhr)
        resolve([])
      },
    })
  })
}

/**
 * Chama POST /Pedido/EnsureMalgaCustomer.
 * Resolve com { ok, missingFields, msg, status } — sem exibir UI.
 */
export function chamaEnsureMalgaCustomer() {
  return new Promise((resolve) => {
    $.ajax({
      url: getUrlAction('pedido', 'EnsureMalgaCustomer'),
      type: 'POST',
      contentType: 'application/json',
      success: (raw) => {
        try {
          const data = typeof raw === 'string' ? JSON.parse(raw) : raw
          resolve({
            ok: !!(data && data.lValid),
            missingFields: (data && data.missingFields) || [],
            msg: (data && data.msg) || '',
            status: (data && data.status) || '',
          })
        } catch (e) {
          sentryError && sentryError(e)
          resolve({ ok: false, missingFields: [], msg: 'Erro inesperado.', status: 'error' })
        }
      },
      error: (xhr) => {
        sentryError && sentryError(xhr)
        resolve({
          ok: false,
          missingFields: [],
          msg: 'Pagamento online indisponível no momento, tente novamente.',
          status: 'error',
        })
      },
    })
  })
}

/**
 * Diálogo pedindo apenas os campos ausentes no cadastro (email, cpf, etc).
 * Persiste via POST /Pedido/AtualizarDadosClienteMalga e resolve com o ensure
 * pós-atualização: { ok, missingFields, msg }.
 */
export function solicitaDadosFaltantesMalga(missingFields) {
  return new Promise((resolve) => {
    ensureMalgaMissingFieldsStyles()

    const setFieldError = (inp, msg) => {
      if (!inp) return
      inp.classList.toggle('malga-missing-input--error', !!msg)
      let err = inp.parentElement.querySelector('.malga-missing-error')
      if (msg) {
        if (!err) {
          err = document.createElement('span')
          err.className = 'malga-missing-error'
          inp.insertAdjacentElement('afterend', err)
        }
        err.textContent = msg
      } else if (err) {
        err.remove()
      }
    }

    const labels = {
      nome: 'Nome completo',
      email: 'E-mail',
      telefone: 'Telefone celular',
      cpf: 'CPF',
    }
    const types = { nome: 'text', email: 'email', telefone: 'tel', cpf: 'text' }
    const placeholders = {
      nome: 'Seu nome',
      email: 'voce@exemplo.com',
      telefone: '(11) 99999-9999',
      cpf: '000.000.000-00',
    }

    const inputsHtml = missingFields
      .map(
        (f) => `
          <label class="malga-missing-label">
            ${labels[f] || f}
            <input type="${types[f] || 'text'}" data-field="${f}" placeholder="${placeholders[f] || ''}"
              class="malga-missing-input" />
          </label>`,
      )
      .join('')

    showMessageBox({
      id: 'malga-missing-fields',
      icon: 'info',
      message: 'Complete seu cadastro para pagar online',
      classList: 'no-icon-background small',
      noEffect: true,
      body: `
        <div class="malga-missing-body">
          <span class="malga-missing-hint">
            Precisamos desses dados pra vincular seu pagamento com segurança.
          </span>
          ${inputsHtml}
          <div class="malga-missing-actions">
            <button class="malga-missing-button malga-missing-button-secondary" id="malga-missing-cancelar">Cancelar</button>
            <button class="malga-missing-button malga-missing-button-primary" id="malga-missing-continuar">Salvar e continuar</button>
          </div>
        </div>`,
    })

    // Máscaras e validação em tempo real após o DOM renderizar
    setTimeout(() => {
      const cpfInp = select('#malga-missing-fields input[data-field="cpf"]')
      const telInp = select('#malga-missing-fields input[data-field="telefone"]')

      if (cpfInp) {
        cpfInp.addEventListener('input', (e) => {
          let v = e.target.value.replace(/\D/g, '').slice(0, 11)
          if (v.length > 9) v = v.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4')
          else if (v.length > 6) v = v.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3')
          else if (v.length > 3) v = v.replace(/(\d{3})(\d{0,3})/, '$1.$2')
          e.target.value = v
          if (v.replace(/\D/g, '').length === 11) {
            setFieldError(cpfInp, TestaCPF(v) ? null : 'CPF inválido.')
          } else {
            setFieldError(cpfInp, null)
          }
        })
      }

      if (telInp) {
        telInp.addEventListener('input', (e) => {
          let v = e.target.value.replace(/\D/g, '').slice(0, 11)
          if (v.length > 10) v = v.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
          else if (v.length > 6) v = v.replace(/(\d{2})(\d{4,5})(\d{0,4})/, '($1) $2-$3')
          else if (v.length > 2) v = v.replace(/(\d{2})(\d{0,5})/, '($1) $2')
          else if (v.length > 0) v = '(' + v
          e.target.value = v
          setFieldError(telInp, null)
        })
        telInp.addEventListener('blur', () => {
          if (telInp.value && telInp.value.replace(/\D/g, '').length < 10) {
            setFieldError(telInp, 'Telefone inválido.')
          }
        })
      }
    }, 10)
    const close = () => {
      const box = select('#malga-missing-fields')
      if (!box) return
      if (box.classList.contains('message-box')) {
        box.remove()
        return
      }
      box.closest('.message-box')?.remove()
    }

    const cancelar = select('#malga-missing-cancelar')
    cancelar &&
      $(cancelar).on('click', () => {
        close()
        resolve({ ok: false, missingFields, msg: 'Cadastro não completado.' })
      })

    const continuar = select('#malga-missing-continuar')
    continuar &&
      $(continuar).on('click', () => {
        const payload = {}
        document
          .querySelectorAll('#malga-missing-fields input[data-field]')
          .forEach((inp) => {
            const key = inp.getAttribute('data-field')
            const val = (inp.value || '').trim()
            if (!val) return
            if (key === 'nome') payload.Nome = val
            if (key === 'email') payload.Email = val
            if (key === 'telefone') payload.Telefone = val
            if (key === 'cpf') payload.Cpf = val
          })

        const faltando = missingFields.filter((f) => {
          if (f === 'nome') return !payload.Nome
          if (f === 'email') return !payload.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.Email)
          if (f === 'telefone') return !payload.Telefone || payload.Telefone.replace(/\D/g, '').length < 10
          if (f === 'cpf') return !TestaCPF(payload.Cpf)
          return false
        })
        if (faltando.length) {
          faltando.forEach((f) => {
            const inp = select('#malga-missing-fields input[data-field="' + f + '"]')
            const label = f === 'cpf' ? 'CPF inválido.'
              : f === 'telefone' ? 'Telefone inválido.'
              : 'Campo obrigatório.'
            setFieldError(inp, label)
          })
          return
        }

        continuar.setAttribute('disabled', 'true')
        continuar.textContent = 'Salvando...'

        $.ajax({
          url: getUrlAction('pedido', 'AtualizarDadosClienteMalga'),
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(payload),
          success: (raw) => {
            try {
              const data = typeof raw === 'string' ? JSON.parse(raw) : raw
              close()
              resolve({
                ok: !!(data && data.lValid),
                missingFields: (data && data.missingFields) || [],
                msg: (data && data.msg) || '',
              })
            } catch (e) {
              sentryError && sentryError(e)
              close()
              resolve({ ok: false, missingFields: [], msg: 'Erro inesperado ao salvar.' })
            }
          },
          error: (xhr) => {
            sentryError && sentryError(xhr)
            continuar.removeAttribute('disabled')
            continuar.textContent = 'Salvar e continuar'
            toast && toast('Não foi possível salvar. Tente novamente.', 'error')
          },
        })
      })
  })
}

/**
 * Orquestra o ensure completo: chama backend, abre diálogo de complementação se
 * necessário e reexecuta até ficar OK ou o usuário cancelar. Resolve true/false.
 */
export async function ensureMalgaCustomerNoBackend() {
  let result = await chamaEnsureMalgaCustomer()

  while (!result.ok && result.missingFields && result.missingFields.length > 0) {
    const updated = await solicitaDadosFaltantesMalga(result.missingFields)
    if (!updated.ok && (!updated.missingFields || updated.missingFields.length === 0)) {
      return false
    }
    if (updated.ok) {
      return true
    }
    result = updated
  }

  if (!result.ok) {
    showMessage(
      'Pagamento online',
      result.msg || 'Pagamento online indisponível no momento.',
      'warning',
      'Entendi',
      () => {
        const btn = select('.message-box button')
        btn && $(btn).on('click', () => select('.message-box').remove())
      },
    )
  }

  return result.ok
}
